import { render, staticRenderFns } from "./LatestPagesHavsutsikt.vue?vue&type=template&id=737769f7&scoped=true&"
import script from "./LatestPagesHavsutsikt.vue?vue&type=script&lang=js&"
export * from "./LatestPagesHavsutsikt.vue?vue&type=script&lang=js&"
import style0 from "./LatestPagesHavsutsikt.vue?vue&type=style&index=0&id=737769f7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737769f7",
  null
  
)

export default component.exports